import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y } from "swiper/modules";
import { IconStarFilled } from "@tabler/icons-react";

// Import Swiper styles
import "swiper/css";

const reviews = [
  {
    name: "Peter Cooper",
    company: "Barone LLC.",
    img: "assets/images/team-1.webp",
    review:
      "Best Freelancer Team! After assessing numerous experts for 2 years, I regret not finding point2solutions sooner. This group is mine, thus I'm hesitant to write it. This is my go-to team!",
  },
  {
    name: "Marvin McKey",
    company: "Biffco Ltd.",
    img: "assets/images/team-2.webp",
    review:
      "Exceptional service! The team's expertise and dedication have significantly improved our IT infrastructure. Highly recommended for any business looking for top-notch IT solutions.",
  },
  {
    name: "Wade Warren",
    company: "Big Kahuna Ltd.",
    img: "assets/images/team-3.webp",
    review:
      "Collaborating with this exceptional team has brought a transformative impact on our company, revolutionizing the way we operate. Their forward-thinking, innovative approaches.",
  },
  {
    name: "Esther Howard",
    company: "Abstergo Industries",
    img: "assets/images/team-4.webp",
    review:
      "I am truly impressed by the exceptional level of professionalism and remarkable technical expertise demonstrated by this team. Their deep understanding of complex IT solutions.",
  },
  {
    name: "Jenny Wilson",
    company: "Binford Ltd.",
    img: "assets/images/team-3.webp",
    review:
      "The exceptional ability of this highly skilled team to thoroughly comprehend the intricate and unique challenges that our organization faces, and to subsequently develop and implement meticulously tailored solutions.",
  },
];

const Views = () => {
  return (
    <div className="section pt-5" style={{ backgroundColor: "#f5f5fd" }}>
      <div className="container"  data-aos="fade-right">
        <div className="mx-auto mb-6 max-w-[838px] text-center lg:mb-8">
          <h5 className="h5 mb-3" style={{ color: "rgb(0, 109, 178)" }}>
            The views expressed by our existing clients
          </h5>
          <h3 className="h3 mb-2 text-title">
            Don’t take our word for it. See what our clients say
          </h3>
          <p className="mx-auto mb-6 max-w-2xl lg:mb-8">
            Here are just a few of our customer feedbacks. Have no trust in what
            we have to say. Have a look at what some of our prior clients have
            said about us.
          </p>
        </div>

        {/* Swiper Slider without Dots & Arrows */}
        <Swiper
          modules={[A11y]}
          spaceBetween={20} // Adjust spacing between slides
          slidesPerView={2} // Default view: 2 slides
          loop={true} // Enables infinite sliding
          breakpoints={{
            0: { slidesPerView: 1 }, // Mobile: 1 slide per view
            768: { slidesPerView: 2 }, // Tablets & desktops: 2 slides per view
          }}
          className="customer-home2-swiper"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="rounded-[20px] border border-transparent p-4 duration-300 lg:px-[30px] lg:py-10">
                <div className="flex gap-1 text-yellow-500">
                  {[...Array(5)].map((_, i) => (
                    <IconStarFilled
                      key={i}
                      size={20}
                      className="text-yellow-500"
                      style={{ color: "rgb(255 187 11)" }}
                    />
                  ))}
                </div>
                <p className="py-4">{review.review}</p>
                <hr className="text-gray" />
                <div className="flex items-center gap-4 pt-4">
                  <img
                    src={review.img}
                    width="50"
                    height="50"
                    alt={review.name}
                    className="rounded-full border-2 border-primary"
                  />
                  <div>
                    <h5 className="h5 mb-1 font-semibold">{review.name}</h5>
                    <p className="sm-text">{review.company}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Views;

